import { render } from "./NewFolderModal.vue?vue&type=template&id=33b84af2&scoped=true"
import script from "./NewFolderModal.vue?vue&type=script&lang=js"
export * from "./NewFolderModal.vue?vue&type=script&lang=js"

import "./NewFolderModal.vue?vue&type=style&index=0&id=33b84af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b84af2"]])

export default __exports__